/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.chevron-double-left\":[\"Double leftward arrow\"]}");